import { WidgetType } from 'enums'
import { usePageConfigUser } from 'hooks/usePageConfig'
import { useMemo } from 'react'
import { PostMetric } from 'schemas/PostMetricSchema'
import { getStreamDataFromPostMetric } from 'utils/streamDataUtil'

const useStreamData = (data: PostMetric) => {
  const { timeZone } = usePageConfigUser()
  return useMemo(
    () =>
      getStreamDataFromPostMetric(data, timeZone, WidgetType.SOCIAL_WEB_POPULAR_POSTS, true, true),
    [data, timeZone]
  )
}

export default useStreamData
